import { render, staticRenderFns } from "./feeDetail.vue?vue&type=template&id=2d94a320&scoped=true"
import script from "./feeDetail.vue?vue&type=script&lang=js"
export * from "./feeDetail.vue?vue&type=script&lang=js"
import style0 from "./feeDetail.vue?vue&type=style&index=0&id=2d94a320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d94a320",
  null
  
)

export default component.exports